import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { SnackbarProvider } from './components/Snackbar';
import Layout from './components/layout/Layout';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import Dashboard from './pages/Dashboard';
import ReportConverter from './components/reports/ReportConverter';
import ReportsList from './components/reports/ReportsList';
import ReportView from './pages/ReportView';
import Feedback from './pages/Feedback';
import Profile from './pages/Profile';
import './components/layout/Layout.css';


const ProtectedLayout = () => {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ padding: 40, color: 'rgba(255,255,255,0.5)' }}>Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout><Outlet /></Layout>;
};

const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/dashboard" replace />;
  return children;
};

const App = () => (
  <AuthProvider>
    <ThemeProvider>
      <SnackbarProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login"    element={<PublicRoute><Login /></PublicRoute>} />
            <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />

            <Route element={<ProtectedLayout />}>
              <Route path="/dashboard"   element={<Dashboard />} />
              <Route path="/reports/new" element={<ReportConverter />} />
              <Route path="/reports"     element={<ReportsList />} />
              <Route path="/reports/:id" element={<ReportView />} />
              <Route path="/feedback"    element={<Feedback />} />
              <Route path="/profile"     element={<Profile />} />
            </Route>

            <Route path="/" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
      </SnackbarProvider>
    </ThemeProvider>
  </AuthProvider>
);

export default App;